exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input{\n    width: 80%;\n    margin-left: auto;\n    margin-right: auto\n}\n.nextday{\n    width: 20%\n}\nth,td{\n    width: 33%\n}\n.header{\n    background-color: #3f4766;\n    width: 662px;\n    position: absolute;\n}\n.header h5{\n    color: white;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/add-attendance-logs/add-attendance-logs.component.css
// module id = ../../../../../src/app/shared/components/add-attendance-logs/add-attendance-logs.component.css
// module chunks = main